import { toast } from '@reelplicate/ui';
import { MutationCache, QueryClient } from '@tanstack/react-query';

import { getErrorMessage } from '@/lib/errors';

export function createQueryClient() {
  return new QueryClient({
    // Mutations report failures as a toast unless the call site handles the
    // error itself (`meta: { silent: true }`) - forms usually do, inline.
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.meta?.silent) return;
        toast.error(getErrorMessage(error));
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          // 4xx won't fix itself by retrying.
          const status = (error as { response?: { status?: number } }).response?.status;
          if (status && status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
        // A query with nothing to show throws to the nearest <QueryBoundary>.
        // One that already has data keeps it on screen and exposes `error` instead.
        throwOnError: (_error, query) => query.state.data === undefined,
      },
    },
  });
}

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { silent?: boolean };
  }
}
